/**
 * @generated SignedSource<<8032ba00fcb2f49cdc701a72be0409b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ModuleOverviewQuery$variables = {
  flowId: UUID;
  skip: boolean;
};
export type ModuleOverviewQuery$data = {
  readonly module?: {
    readonly flow: {
      readonly name: string;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CommentsTab_moduleComments" | "DeliverTab_moduleDeliverableAsset" | "OverviewTab_module">;
  } | null | undefined;
};
export type ModuleOverviewQuery = {
  response: ModuleOverviewQuery$data;
  variables: ModuleOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "flowId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "flowId",
    "variableName": "flowId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedToId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gwtUserId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentText",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseTo",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "GwtUser",
  "kind": "LinkedField",
  "name": "gwtUser",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lanId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModuleOverviewQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Module",
            "kind": "LinkedField",
            "name": "module",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Flow",
                "kind": "LinkedField",
                "name": "flow",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CommentsTab_moduleComments"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OverviewTab_module"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DeliverTab_moduleDeliverableAsset"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModuleOverviewQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Module",
            "kind": "LinkedField",
            "name": "module",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Flow",
                "kind": "LinkedField",
                "name": "flow",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "comment": {
                            "responseTo": {
                              "isNull": true
                            }
                          }
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": "COMMENT_BY_COMMENT_ID__CREATED_AT_DESC"
                      }
                    ],
                    "concreteType": "FlowCommentsConnection",
                    "kind": "LinkedField",
                    "name": "flowComments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowComment",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Flow",
                            "kind": "LinkedField",
                            "name": "flow",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "comment",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": "CREATED_AT_ASC"
                                  }
                                ],
                                "concreteType": "CommentsConnection",
                                "kind": "LinkedField",
                                "name": "commentsByResponseTo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v13/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "commentsByResponseTo(orderBy:\"CREATED_AT_ASC\")"
                              },
                              (v10/*: any*/),
                              (v13/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "flowComments(filter:{\"comment\":{\"responseTo\":{\"isNull\":true}}},orderBy:\"COMMENT_BY_COMMENT_ID__CREATED_AT_DESC\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignmentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignmentDueAtStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GwtUser",
                    "kind": "LinkedField",
                    "name": "assignedTo",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": "PRIORITY_ASC"
                  }
                ],
                "concreteType": "TasksConnection",
                "kind": "LinkedField",
                "name": "tasksByModuleFlowId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priority",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flow",
                        "kind": "LinkedField",
                        "name": "flow",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "complete",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "tasksByModuleFlowId(orderBy:\"PRIORITY_ASC\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "galleryAssetComponentsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attempts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submissionLock",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "galleryAssetDeliverableId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": "ATTEMPT_DESC"
                  }
                ],
                "concreteType": "ModuleSubmissionsConnection",
                "kind": "LinkedField",
                "name": "moduleSubmissionsByModuleFlowId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModuleSubmission",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attempt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "galleryAssetSubmissionId",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "submissionStatus",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "moduleSubmissionsByModuleFlowId(orderBy:\"ATTEMPT_DESC\")"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f17a99b90224b928065457114fc3ee00",
    "id": null,
    "metadata": {},
    "name": "ModuleOverviewQuery",
    "operationKind": "query",
    "text": "query ModuleOverviewQuery(\n  $flowId: UUID!\n  $skip: Boolean!\n) {\n  module(flowId: $flowId) @skip(if: $skip) {\n    flow {\n      name\n      id\n    }\n    ...CommentsTab_moduleComments\n    ...OverviewTab_module\n    ...DeliverTab_moduleDeliverableAsset\n    id\n  }\n}\n\nfragment CommentAddFragment on Flow {\n  rowId\n  name\n  assignedToId\n}\n\nfragment CommentCardFragment on FlowComment {\n  ...CommentReplyFragment\n  flowId\n  comment {\n    ...EditableComment_editable\n    ...CommentOptions_comment\n    rowId\n    commentsByResponseTo(orderBy: CREATED_AT_ASC) {\n      nodes {\n        ...CommentCardResponseFragment\n        id\n      }\n    }\n    createdAt\n    commentText\n    gwtUser {\n      ...UserAvatar_gwtUser\n      id\n    }\n    id\n  }\n}\n\nfragment CommentCardResponseFragment on Comment {\n  ...CommentOptions_comment\n  ...EditableComment_editable\n  createdAt\n  rowId\n  gwtUser {\n    ...UserAvatar_gwtUser\n    id\n  }\n}\n\nfragment CommentOptions_comment on Comment {\n  rowId\n  gwtUserId\n  commentText\n  responseTo\n}\n\nfragment CommentReplyFragment on FlowComment {\n  flow {\n    name\n    assignedToId\n    id\n  }\n  flowId\n  commentId\n}\n\nfragment CommentsTab_moduleComments on Module {\n  flow {\n    rowId\n    ...CommentAddFragment\n    flowComments(filter: {comment: {responseTo: {isNull: true}}}, orderBy: COMMENT_BY_COMMENT_ID__CREATED_AT_DESC) {\n      nodes {\n        commentId\n        ...CommentCardFragment\n        id\n      }\n    }\n    id\n  }\n  id\n}\n\nfragment DeliverTab_moduleDeliverableAsset on Module {\n  flow {\n    assignmentStatus\n    assignedTo {\n      firstName\n      lastName\n      id\n    }\n    id\n  }\n  submissionLock\n  ...DeliverableFileUploadTable_galleryAsset\n  ...SubmitButton_Fragment\n  ...SubmittedAssetFilesDisplay_Fragment\n  galleryAssetDeliverableId\n  tasksByModuleFlowId(orderBy: PRIORITY_ASC) {\n    nodes {\n      flowId\n      complete\n      ...TaskCompleteCheckbox_task\n      flow {\n        name\n        id\n      }\n      id\n    }\n  }\n  moduleSubmissionsByModuleFlowId(orderBy: ATTEMPT_DESC) {\n    nodes {\n      submissionStatus\n      id\n    }\n  }\n}\n\nfragment DeliverableFileUploadTable_galleryAsset on Module {\n  flowId\n  galleryAssetDeliverableId\n}\n\nfragment EditableComment_editable on Comment {\n  rowId\n  gwtUserId\n  commentText\n}\n\nfragment OverviewTab_module on Module {\n  flow {\n    rowId\n    name\n    description\n    assignedAt\n    dueAt\n    ...StatusChip_flow\n    id\n  }\n  tasksByModuleFlowId(orderBy: PRIORITY_ASC) {\n    nodes {\n      priority\n      flow {\n        rowId\n        name\n        id\n      }\n      id\n    }\n  }\n  galleryAssetComponentsId\n  attempts\n}\n\nfragment StatusChip_flow on Flow {\n  dueAt\n  assignmentStatus\n  assignmentDueAtStatus\n}\n\nfragment SubmitButton_Fragment on Module {\n  flowId\n  flow {\n    name\n    id\n  }\n}\n\nfragment SubmittedAssetFilesDisplay_Fragment on Module {\n  flow {\n    assignedTo {\n      fullName\n      id\n    }\n    id\n  }\n  moduleSubmissionsByModuleFlowId(orderBy: ATTEMPT_DESC) {\n    nodes {\n      attempt\n      galleryAssetSubmissionId\n      createdAt\n      id\n    }\n  }\n}\n\nfragment TaskCompleteCheckbox_task on Task {\n  flowId\n  complete\n  priority\n  flow {\n    name\n    id\n  }\n}\n\nfragment UserAvatar_gwtUser on GwtUser {\n  id\n  firstName\n  lastName\n  lanId\n}\n"
  }
};
})();

(node as any).hash = "6381b470790e8cd3cb67b1024dac7e58";

export default node;
